import { render } from "./FaqModal.vue?vue&type=template&id=2a3aca66&scoped=true"
import script from "./FaqModal.vue?vue&type=script&lang=js"
export * from "./FaqModal.vue?vue&type=script&lang=js"

import "./FaqModal.vue?vue&type=style&index=0&id=2a3aca66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3aca66"]])

export default __exports__